<template>
  <div 
    class="xit-fb-template node user-input-flow-bg"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="fab fa-stack-overflow card-start-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">

      <div ref="displayStatHtml"></div>

      <div class="card-data">
        <div class="list-group bg-white"
          v-if="node.data.userInputFlowIdValue && 'new' === node.data.userInputFlowIdValue">
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start">
            <small class="text-muted"><a>{{ user_input_flow_template_campaign_name }}</a></small>
            <p class="mb-0">{{ node.data.campaignName || '' }}</p>
          </span>
          <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"
            v-if="node.data.buttonWebhookUrl && node.data.buttonWebhookUrl">
            <small class="text-muted"><a>{{ button_html_label_webhook_url }}</a></small>
            <p class="mb-0">
              <a :href="node.data.buttonWebhookUrl" :title="node.data.buttonWebhookUrl"
                target="_BLANK">{{node.data.buttonWebhookUrl.length>40 ? node.data.buttonWebhookUrl.slice(0, 40)+'...' :
                node.data.buttonWebhookUrl }}...</a>
            </p>
          </span>
          <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"
            v-if="getSelectedGoogleSheets(node)">
            <small class="text-muted">{{ button_html_google_sheet_add }}</small>
            <p class="mb-0"> {{ getSelectedGoogleSheets(node) }}</p>
          </span>
        </div>
        <div class="list-group bg-white"
          v-else-if="node.data.userInputFlowIdValue && 'new' != node.data.userInputFlowIdValue">
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start">
            <small class="text-muted"><a>{{ user_input_flow_template_campaign_name }}</a></small>
            <p class="mb-0">{{ node.data.userInputFlowIdText || '' }}</p>
          </span>
          <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"
            v-if="node.data.buttonWebhookUrl && node.data.buttonWebhookUrl">
            <small class="text-muted"><a>{{ button_html_label_webhook_url }}</a></small>
            <p class="mb-0">
              <a :href="node.data.buttonWebhookUrl" :title="node.data.buttonWebhookUrl" target="_BLANK">{{
                node.data.buttonWebhookUrl.length > 40 ? node.data.buttonWebhookUrl.slice(0, 40) + '...' :
                node.data.buttonWebhookUrl}}...</a>
            </p>
          </span>
          <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"
            v-if="getSelectedGoogleSheets(node)">
            <small class="text-muted">{{ button_html_google_sheet_add }}</small>
            <p class="mb-0"> {{ getSelectedGoogleSheets(node) }}</p>
          </span>
        </div>
        <div v-else class="tdouble-click-div text-center">
          <img :src="icon_doubletap" :title="double_click_for_settings">
        </div>
      </div>

      <div class="card-sockets" style="flex-direction: row !important;">
        <div class="input text-left" v-for="input in inputs()" :key="input.key"
          :class="hasConnection(input) ? 'has-connection' : ''">
          <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
          <div class="input-title">{{ input.name }}</div>
        </div>

        <div class="output text-right" v-for="output in outputs()" :key="output.key"
          :class="hasConnection(output) ? 'has-connection' : ''">
          <div class="output-title">{{output.name}}</div>
          <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'

import { lang } from '../../assets/lang'
import { templateComponentMethods, updateNodeConnections } from '../../utils/functions'

export default {
  name: 'UserInputFlowTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    sec: lang.common_info_sec,
    baseUrl: window.xitFlowBuilderData.base_url,
    typing_display: lang.common_info_typing_display,
    double_click_for_settings: lang.double_click_for_settings,
    icon_doubletap: window.xitFlowBuilderData.icon_doubletap,
    button_html_label_webhook_url: lang.button_html_label_webhook_url,
    button_html_google_sheet_add: button_html_google_sheet_add,
    user_input_flow_template_campaign_name: lang.user_input_flow_template_campaign_name,
  }),

  methods: {
    ...templateComponentMethods,
    getSelectedGoogleSheets(node) {
      const googleSheetsArray = node.data.googleSheetsArray || []
      return googleSheetsArray.join(', ')
    },
  },

  async mounted() {
    const result = await this.displayStat(this.$props.node)
    $(this.$refs.displayStatHtml).html(result)

    updateNodeConnections(this.$props.node)
  }
}
</script>